export default (editor, config = {}) => {
  const bm = editor.BlockManager;

  const pfx = '[data-gjs-type="linkedin_widget"]';
  const style = `<style>
    ${pfx} {
      height: 70%;
      width: 60%;
      position: relative;
    }
    ${pfx}:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    section ${pfx}:after {
      content: none;
    }
  </style>`;
  bm.add('linkedin_widget', {
    label: 'Linkedin',
    category: 'Social',
    content: `
        <div data-gjs-type="linkedin_widget"></div>
        ${style}
      `,
    attributes: {
      class: 'fa fa-linkedin-square' //icon in the panel
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/linkedin/blocks.js